<div class="full-width card">
  <div class="card-header">
    @if (isCustomRuleCreate) {
      <div class="row mb-3">
        <div class="col-12">
          <div class="d-flex">
            <ds-link [rtLink]="backLink" [standalone]="true">
              {{ 'rule_libraries' | translate }}
            </ds-link>
          </div>
        </div>
      </div>
      <div class="row align-items-center justify-content-between">
        <ng-container *ngTemplateOutlet="pageHeader"></ng-container>
      </div>
    } @else {
      <div class="row">
        <ng-container *ngTemplateOutlet="pageHeader"></ng-container>
      </div>
    }
    <ng-template #pageHeader>
      <div class="col-12">
        <h1 class="d-inline-block">{{ headingTitleKey | translate }}</h1>
      </div>
    </ng-template>
  </div>
  <div class="card-body">
    @if (isCustomRuleCreate) {
      <div class="row mt-4">
        <div class="col-12">
          <ng-container *ngTemplateOutlet="pageForm"></ng-container>
        </div>
      </div>
    } @else {
      <app-upsert-audit-rule-form
        [action]="this.auditRuleAction"
        [auditRuleData]="this.auditRule"
        [isCustomAuditRule]="!this.isMasterRule"
        (save)="save($event)"
      ></app-upsert-audit-rule-form>
    }
    <ng-template #pageForm>
      <app-upsert-audit-rule-form
        [action]="this.auditRuleAction"
        [auditRuleData]="this.auditRule"
        [isCustomAuditRule]="!this.isMasterRule"
        (save)="save($event)"
      ></app-upsert-audit-rule-form>
    </ng-template>
  </div>
</div>
